import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "layout-page" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "flex-grow-1 container-p-y px-4" }
const _hoisted_4 = { class: "d-flex justify-content-between aling-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold py-3 mb-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-light" }, "Category"),
    /*#__PURE__*/_createTextVNode(" Form ")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Back to List")
const _hoisted_7 = { class: "" }
const _hoisted_8 = {
  key: 0,
  class: "alert alert-success alert-dismissible",
  role: "alert"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Successfully ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "aria-label": "Close"
}, null, -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-12 col-sm-12" }
const _hoisted_14 = { class: "card" }
const _hoisted_15 = { class: "card-body" }
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = { class: "row mb-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-sm-12 col-form-label",
  for: "basic-icon-default-fullname"
}, "Select Type", -1)
const _hoisted_19 = { class: "col-sm-12" }
const _hoisted_20 = { class: "input-group input-group-merge" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", {
  id: "basic-icon-default-fullname2",
  class: "input-group-text"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bx bx-buildings" })
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "-- Select Type-- ", -1)
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "row mb-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-sm-12 col-form-label",
  for: "basic-icon-default-fullname"
}, "Category Name", -1)
const _hoisted_26 = { class: "col-sm-12" }
const _hoisted_27 = { class: "input-group input-group-merge" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", {
  id: "basic-icon-default-fullname2",
  class: "input-group-text"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bx bx-buildings" })
], -1)
const _hoisted_29 = {
  key: 0,
  class: "form-control suggestions-list"
}
const _hoisted_30 = { class: "row mb-3" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-sm-12 col-form-label",
  for: "basic-icon-default-store"
}, "Category Description ", -1)
const _hoisted_32 = { class: "col-sm-12" }
const _hoisted_33 = { class: "col-md-12 col-sm-12" }
const _hoisted_34 = { class: "row justify-content-end" }
const _hoisted_35 = { class: "col-sm-12" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  key: 1,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_39 = {
  key: 2,
  class: "visually-show"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopBarView = _resolveComponent("TopBarView")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TopBarView),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", null, [
                _createVNode(_component_router_link, {
                  to: "/category_setting",
                  class: "btn btn-primary mt-2"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.successReport)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
                : _createCommentVNode("", true),
              _createElementVNode("form", {
                name: "",
                onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _hoisted_18,
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _hoisted_21,
                                _withDirectives(_createElementVNode("select", {
                                  class: "form-select",
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.type_id) = $event))
                                }, [
                                  _hoisted_22,
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fetchTypeList, (type) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: type.id,
                                      value: type.id
                                    }, _toDisplayString(type.title), 9, _hoisted_23))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, _ctx.formData.type_id]
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _hoisted_25,
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _hoisted_28,
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "form-control",
                                  id: "basic-icon-default-fullname",
                                  placeholder: "Name",
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.name) = $event)),
                                  required: "",
                                  onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.searchCategory && _ctx.searchCategory(...args)))
                                }, null, 544), [
                                  [_vModelText, _ctx.formData.name]
                                ])
                              ]),
                              (_ctx.suggestions.length)
                                ? (_openBlock(), _createElementBlock("ul", _hoisted_29, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestions, (category) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: category.id,
                                        class: "p-2"
                                      }, _toDisplayString(category.name), 1))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _hoisted_31,
                            _createElementVNode("div", _hoisted_32, [
                              _withDirectives(_createElementVNode("textarea", {
                                class: "form-control",
                                id: "exampleFormControlTextarea1",
                                rows: "4",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.description) = $event)),
                                placeholder: "Description"
                              }, null, 512), [
                                [_vModelText, _ctx.formData.description]
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("button", {
                          type: "submit",
                          class: "btn btn-primary mt-3",
                          disabled: _ctx.submitBtn
                        }, [
                          (!_ctx.submitBtn)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_37, "Save"))
                            : _createCommentVNode("", true),
                          (_ctx.submitBtn)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_38))
                            : _createCommentVNode("", true),
                          (_ctx.submitBtn)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_39, " Saving..."))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_36)
                      ])
                    ])
                  ])
                ])
              ], 32)
            ])
          ])
        ])
      ]),
      _createVNode(_component_Footer)
    ])
  ]))
}